import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { findFacility, type Facility } from "@penmate/react-shared/api/facilities";

const DEBOUNCE_MS = 300;
const MIN_QUERY_LENGTH = 2;

export function useFacilityTypeahead(state: string, q: string) {
  const [debouncedQ, setDebouncedQ] = useState(q);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedQ(q), DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [q]);

  const enabled = debouncedQ.trim().length >= MIN_QUERY_LENGTH && state.length > 0;

  const query = useQuery<Facility[]>({
    queryKey: ["facilities", state, debouncedQ.trim().toLowerCase()],
    queryFn: () => findFacility({ q: debouncedQ.trim(), state, email: false }),
    enabled,
    staleTime: 5 * 60_000,
  });

  return {
    facilities: enabled && query.data ? query.data : [],
    isSearching: enabled && query.isFetching,
    // True only once a fetch for the current (debounced) term has completed —
    // gates the empty state so it can't flash during the debounce window.
    hasResults: enabled && query.isFetched && debouncedQ === q,
  };
}
